import moment from 'moment-timezone';

import React from 'react';
import styled from 'styled-components';

import { Link } from 'react-router-dom';

import AntdDescriptions from 'antd/lib/descriptions';
import AntdTable from 'antd/lib/table';

import Types from '../../modules/types';
import getRoleBasedPath from '../../helpers/getRoleBasedPath';

const OrdersTable = styled(AntdTable)`
  .ant-table-body {
    margin: 0px !important;
  }
  td {
    position: relative;
  }
`;

export const fieldInfo = ['FieldReact', {
  label: null,
  renderContent: (props) => {
    const { data } = props;
    if (!data) {
      return null;
    }
    return (
      <AntdDescriptions column={1}>
        <AntdDescriptions.Item label="Status">
          {
              !data.ready
            ? 'Awaiting Confirmation'
            : data.done ? 'Done'
            : 'Processing'
          }
        </AntdDescriptions.Item>
        <AntdDescriptions.Item label="Company">
          {
            data.company?.name
            ? (
                <Link to={`/shippingcompanies/${data.company._id}`}>
                  {data.company.name}
                </Link>
              )
            : 'N/A'
          }
        </AntdDescriptions.Item>
        <AntdDescriptions.Item label="Submitted At">
          {moment(data.createdAt).format('llll')}
        </AntdDescriptions.Item>
        <AntdDescriptions.Item label="Submitted By">
          {
            data.createdBy?.name
            ? (
                <Link to={`/users/${data.createdBy._id}`}>
                  {data.createdBy.name}
                </Link>
              )
            : 'N/A'
          }
        </AntdDescriptions.Item>
      </AntdDescriptions>
    );
  },
}];

const StatusSpan = styled.span`
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  padding: 8px 8px;
`;

export const fieldOrders = ['FieldReact', {
  label: null,
  ContentComponent: (props) => {
    const { data } = props;
    const { ready = true } = data || {};
    const { importColumnsValueIds = [] } = data?.company || {};
    const columns = React.useMemo(
      () => [
        {
          title: 'Order',
          dataIndex: 'order',
          key: 'order',
          fixed: true,
          render: (text) => (
            <Link to={`${getRoleBasedPath(props, `/orders/${text}`)}`}>
              {text}
            </Link>
          ),
        },
        {
          title: 'Action',
          dataIndex: 'action',
          key: 'action',
          // fixed: true,
          render: (text) => (
            <span style={{ whiteSpace: 'nowrap' }}>
              {
                  text === 'DELIVERY' ? 'Set On Delivery'
                : text === 'DELIVERED' ? 'Set As Delivered'
                : text === 'FAILED' ? 'Set As Failed'
                : '-'
              }
            </span>
          ),
        },
        {
          title: 'Status',
          dataIndex: 'done',
          width: '100%',
          key: 'done',
          ellipsis: true,
          render: (text, record) => {
            let status = 'Done';
            if (!ready) {
              status = 'Awaiting Confirmation';
            } else if (!record.done) {
              // eslint-disable-next-line max-len
              status = 'Processing';
            } else if (record.error) {
              status = `Error: ${record.error}`;
            }
            if (record.action === 'SKIP') {
              status = `${status} (Skipped)`;
            }
            return (
              <>
                <span style={{ display: 'inline-block', minWidth: '200px' }} />
                <StatusSpan
                  title={status}
                >
                  {status}
                </StatusSpan>
              </>
            );
          },
        },
        ...Types.SHIPPING_COMPANIES_IMPORT_VALUES_LIST.reduce(
          (agr, importValue) => {
            if (!['ACTION', 'ORDER_ID'].includes(importValue.id)) {
              if (importColumnsValueIds.includes(importValue.id)) {
                const column = {
                  title: (
                    <span style={{ whiteSpace: 'nowrap' }}>
                      {importValue.labelShort || importValue.label}
                    </span>
                  ),
                  dataIndex: importValue.id,
                  key: importValue.id,
                  render: text => (
                    <span style={{ whiteSpace: 'nowrap' }}>
                      {text || '-'}
                    </span>
                  ),
                };
                agr.push(column);
              }
            }
            return agr;
          },
          [],
        ),
      ],
      [ready, importColumnsValueIds, props],
    );
    const dataSource = React.useMemo(
      () => (data.orders || []).map(order => ({
        ...order.values,
        ...order,
      })),
      [data.orders],
    );
    return (
      <OrdersTable
        columns={columns}
        dataSource={dataSource}
        size="small"
        pagination={false}
        scroll={{ x: true }}
        rowKey="_id"
        bordered
      />
    );
  },
}];

export const ADMIN = [
  ['FieldTitle', {
    title: 'Info',
  }],
  fieldInfo,
  ['FieldTitle', {
    title: 'Sheet',
  }],
  fieldOrders,
];
